import classNames from 'classnames'
import { SaleTag } from 'components/tag/SaleTag'
import React, {
  Dispatch,
  PropsWithChildren,
  SetStateAction,
  useEffect,
  useState,
} from 'react'
import { isMobile } from 'react-device-detect'
import {
  Control,
  Controller,
  UseFormSetValue,
  UseFormWatch,
} from 'react-hook-form'
import { ShortVideoTemplateType, TemplateItem } from 'service/list'
import { Me } from 'service/user'
import { contentVideoFormValues } from 'utils/type'
import { CustomImage } from '../Image'
import { Modal } from 'components/layout/Modal'
import { SelectionModal } from 'components/layout/SelectionModal'
import { ReactComponent as StarIcon } from 'svg/star_white.svg'
import { TextArea } from 'components/atom/TextArea'
import { THUMBNAIL_PATTERN } from 'utils/common'
import { UpdateTag } from 'components/tag/UpdateTag'
import TemplateTooltip from 'pages/content-video-editor/components/shortvideo/TemplateTooltip'
import HoverVideo from '../HoverVideo'
interface ContentLayoutSelectorProps {
  watch: UseFormWatch<contentVideoFormValues>
  setValue: UseFormSetValue<contentVideoFormValues>
  control: Control<contentVideoFormValues, any>
  translatePlanName?: (planName: string) => string
  userInfo: Me
  templateList: ShortVideoTemplateType | undefined
  splitTitles: string[]
  selectedImagePath: string
  setSelectedImagePath: Dispatch<SetStateAction<string>>
}

export const ContentLayoutSelector = ({
  watch,
  setValue,
  control,
  translatePlanName,
  userInfo,
  templateList,
  splitTitles,
  selectedImagePath,
  setSelectedImagePath,
}: PropsWithChildren<ContentLayoutSelectorProps>) => {
  const [placidTemplateList, setPlacidTemplateList] = useState<any>(
    templateList?.placid,
  )

  const [isModalOpen, setIsModalOpen] = useState<boolean>(false)
  const [templateTooltip, setTemplateTooltip] = useState<boolean>(false)

  const handleSaveBtn = () => {
    /**
     * 1.templateTitle length !== 0
     * 2. templateId !== 0
     * 위에 확인후 조건이 맞을시
     * 3. setIsModalOpen === false
     */

    const templateTitleLen = watch('templateTitle').length
    const templateId = watch('templateId')

    if (templateTitleLen !== 0 && templateId !== 0) {
      return setIsModalOpen(false)
    }
  }
  useEffect(() => {
    if (templateList?.placid) setPlacidTemplateList(templateList.placid)
  }, [templateList])

  return (
    <>
      <div className="content_layout_selector mb-10">
        <div
          className={classNames('', {
            'flex items-center gap-10 gap-3': !isMobile,
          })}
        >
          <div className="title flex shrink-0 flex-col gap-2 text-[18px] font-bold">
            <div>
              <UpdateTag />
            </div>
            <p className="relative flex w-[92px] shrink-0 items-center gap-[6px] text-[18px] font-bold">
              영상 제목
              <br />
              화면 구성
            </p>
          </div>

          <div
            className={classNames('rounded-[10px] px-4', {
              'selector_list flex min-h-[116px] w-full items-center justify-between gap-2 bg-[#F6F8FB]':
                !isMobile,
              'selector_list flex min-h-[116px] w-full flex-col gap-2 bg-[#F6F8FB]':
                isMobile,
            })}
          >
            <div className="flex gap-5">
              <div className="flex items-center gap-1">
                <p className="rounded-[4px] bg-[#D9DEE8] px-1 py-[2px] text-[14px] font-bold text-[#8F929B]">
                  영상 제목
                </p>
                <p className="min-h-[48px] min-w-[143px] rounded-[4px] bg-[#EEF1F7] px-2 py-1">
                  {(watch('templateTitle') as string).split('\n').map((el) => (
                    <>
                      {el} <br />
                    </>
                  ))}
                </p>
              </div>
              <div className="flex items-center gap-1">
                <p className="rounded-[4px] bg-[#D9DEE8] px-1 py-[2px] text-[14px] font-bold text-[#8F929B]">
                  화면 구성
                </p>

                {selectedImagePath && (
                  <p className="h-[100px] w-[57px]">
                    <CustomImage
                      path={selectedImagePath}
                      width={57}
                      height={100}
                    />
                  </p>
                )}
              </div>
            </div>
            <button
              className="rounded-[4px] bg-[#2E343D] px-2 py-[6px] text-[14px] text-[white]"
              onClick={() => {
                setIsModalOpen(true)
              }}
              type="button"
            >
              선택 {'>'}
            </button>
          </div>
        </div>
      </div>
      <SelectionModal isModal={isModalOpen}>
        {
          <div
            className={classNames('', {
              'flex h-auto flex-col gap-8 rounded-t-[20px] bg-white px-8 pb-44 pt-8 shadow-main md:w-[816px]':
                !isMobile,
              'flex w-full flex-col gap-8 bg-white px-4 pt-10 shadow-main':
                isMobile,
            })}
          >
            <div className="title flex flex-col gap-4">
              <p className="flex items-center justify-between">
                <span className="text-left text-[24px] font-bold">
                  영상 제목 + 화면 구성
                </span>
                {/* <button
                  onClick={() => {
                    setIsModalOpen(false)
                  }}
                  className=" flex items-center"
                >
                  <img
                    src="assets/img/Icon_x.png"
                    alt="icon_x"
                    height={40}
                    width={40}
                  />
                </button> */}
              </p>
              <div className="flex items-center gap-2">
                <img
                  src="assets/img/cash.png"
                  alt="point"
                  width={11}
                  height={13}
                />

                <span className="text-main">30 캐시</span>
              </div>
            </div>
            {/* ai title input */}
            <div className="flex flex-col items-start gap-4">
              <div className="flex flex-col items-start">
                <p className="relative flex items-center gap-2 text-[18px] font-bold">
                  영상용 제목 입력{' '}
                  <TemplateTooltip
                    templateTooltip={templateTooltip}
                    setTemplateTooltip={setTemplateTooltip}
                  />
                </p>
                <p className="text-[14px] text-main">
                  영상 상단에 들어갈 제목입니다.
                </p>
              </div>
              <div className="ai title list flex w-full flex-col gap-2">
                <span className="inline-flex w-[90px] gap-1 rounded-[4px] bg-black p-1 text-[12px] font-bold text-white">
                  <StarIcon />
                  AI 생성 제목
                </span>
                <div className="flex flex-wrap gap-3">
                  {splitTitles?.map((el, index) => (
                    <button
                      className={classNames(
                        'rounded-[4px] px-2 py-1 text-left',
                        {
                          'bg-[#EEF1F7] hover:bg-[#BBEBEC]':
                            watch('templateTitle') !== el,
                          'bg-[#BBEBEC]': watch('templateTitle') === el,
                        },
                      )}
                      type="button"
                      onClick={() => {
                        setValue('templateTitle', el)
                      }}
                    >
                      {el.split('\n').map((el) => {
                        return (
                          <>
                            {el} <br />
                          </>
                        )
                      })}
                    </button>
                  ))}
                </div>
                <div className="flex flex-col items-start gap-2">
                  <Controller
                    key="templateTitle"
                    render={({ field }) => {
                      const handleInput = (
                        e: React.ChangeEvent<HTMLTextAreaElement>,
                      ) => {
                        const value = e.target.value
                        const lines = value.split('\n').length
                        if (lines > 3) {
                          const trimmedValue = value
                            .split('\n')
                            .slice(0, 4)
                            .join('\n')

                          field.onChange(trimmedValue) // 강제로 잘라서 저장
                        } else {
                          field.onChange(value) // 정상 입력
                        }
                      }
                      return (
                        <>
                          {
                            <>
                              <TextArea
                                {...field}
                                error={watch('templateTitle').length === 0}
                                maxLength={26}
                                placeholder={
                                  '한 줄에 10자가 넘지 않게 제목을 입력해야\n화면 구성에 잘 어울려요!'
                                }
                                width="w-full"
                                onInput={handleInput}
                              />
                            </>
                          }
                          <p
                            className={`mb-1 flex gap-[4px] ${
                              !THUMBNAIL_PATTERN.test(field.value) &&
                              'text-error'
                            }`}
                          >
                            <span className="text-left">
                              {field.value.length}/26{' '}
                              {`이모지는 허용되지 않습니다.`}
                              (한 줄에 10자가 넘지 않게 제목을 입력해야 화면
                              구성에 잘 어울려요!)
                            </span>
                          </p>
                        </>
                      )
                    }}
                    name="templateTitle"
                    control={control}
                    rules={{
                      required: {
                        value: true,
                        message: '영상 제목은 필수입니다!',
                      },
                      validate: (value) => {
                        if (!value || value.trim() === '') {
                          return '영상 제목은 필수입니다!'
                        }
                        if (!THUMBNAIL_PATTERN.test(value)) {
                          return '이모지는 허용되지 않습니다.'
                        }
                        return true
                      },
                    }}
                  />
                </div>
              </div>
            </div>
            {/* template list */}
            <div className="template_list flex flex-col items-start gap-4">
              <p className="text-[18px] font-bold">화면 구성 </p>
              <div
                className={classNames('', {
                  'grid grid-cols-5 gap-[14px]': !isMobile,
                  'grid w-full grid-cols-2 gap-[26px] px-8': isMobile,
                })}
              >
                {placidTemplateList?.list?.map((el: any, index: number) => (
                  <div key={el?.id || index}>
                    <Controller
                      render={({ field }: any) => (
                        <div
                          className="relative cursor-pointer"
                          onClick={() => {
                            setValue('templateId', el?.id)
                            setValue('templateType', el?.type)
                            setSelectedImagePath(el?.path)
                          }}
                        >
                          <div className="absolute bottom-2 right-2">
                            <input
                              type="checkbox"
                              className="sr-only"
                              onChange={() => {}}
                            />
                            <div
                              className={`flex h-[20px] w-[20px] items-center justify-center rounded-full border-2 bg-main ${
                                watch('templateId') === el?.id
                                  ? 'border-main bg-white'
                                  : 'bg-white'
                              }`}
                            >
                              {watch('templateId') === el?.id && (
                                <div className="h-3 w-3 rounded-full bg-main"></div>
                              )}
                            </div>
                          </div>
                          <HoverVideo
                            videoPath={el?.videoPath}
                            path={el?.path}
                            index={index}
                          />
                        </div>
                      )}
                      name="templateId"
                      control={control}
                    />
                  </div>
                ))}
              </div>
            </div>
            {isMobile && (
              <div className="pb-20">
                <button
                  className="z-50 h-[60px] w-full rounded-full bg-main font-bold text-white disabled:opacity-40"
                  type="button"
                  onClick={handleSaveBtn}
                  disabled={
                    watch('templateId') === 0 ||
                    watch('templateTitle').length === 0
                  }
                >
                  저장
                </button>
              </div>
            )}
          </div>
        }
        {!isMobile && (
          <div className="sticky bottom-0 z-50 w-full rounded-b-[20px] bg-white p-8 shadow-main before:absolute before:left-0 before:top-[-10px] before:h-[10px] before:w-full before:bg-gradient-to-t before:from-black/10 before:to-transparent before:content-[''] md:w-[816px]">
            <button
              className="z-50 h-[60px] w-full rounded-full bg-main font-bold text-white disabled:opacity-40"
              type="button"
              onClick={handleSaveBtn}
              disabled={
                watch('templateId') === 0 || watch('templateTitle').length === 0
              }
            >
              저장
            </button>
          </div>
        )}
      </SelectionModal>
    </>
  )
}
